import { useState, useEffect } from "react";
import { MetaData } from "../interface";

export default function usePagination(defaultPageSize = 5, tableKey: string) {
  // 1️⃣ Try to read saved state from localStorage
  const savedMeta = typeof window !== "undefined" ? localStorage.getItem(tableKey) : null;
  const initialMeta: MetaData = savedMeta
    ? JSON.parse(savedMeta)
    : {
        currentPage: 1,
        pageSize: defaultPageSize,
        totalRecords: 0,
        totalPages: 1,
      };

  const [meta, setMeta] = useState<MetaData>(initialMeta);

  // 2️⃣ Save pagination state to localStorage whenever it changes
  useEffect(() => {
    if (tableKey) {
      localStorage.setItem(tableKey, JSON.stringify(meta));
    }
  }, [meta, tableKey]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setMeta((prev) => ({ ...prev, currentPage: newPage + 1 }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newSize = parseInt(event.target.value, 10);
    setMeta((prev) => ({
      ...prev,
      pageSize: newSize,
      currentPage: 1, // reset page
    }));
  };

  return {
    meta,
    setMeta,
    handleChangePage,
    handleChangeRowsPerPage,
  };
}
